// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"62f0fb0d","421":"bf35ec56"}[chunkId] + ".chunk.css";
};